import React, { useEffect, useRef, useContext, useCallback } from "react";
import $ from "jquery";
import UIkit from 'uikit/dist/js/uikit';

const SearchForm = (props) => {


  return (
    <>
      <div className="search-form-wrp">
        <div className={`hero-search-form`}>
          <form>
            <label htmlFor="search">Search</label>
            <input
              aria-label="search"
              id="search" type="text"
              name="search"
              className={`st-default-search-input`}
              placeholder={`${props.placeholder ? (props.placeholder) : (null)}`}
            />
            <label htmlFor="search-btn-hero">Searchbtn</label>
            <input aria-label="search btn hero" type="submit" id="search-btn-hero" name="search-btn-hero" value="Search" className="hero-search-button" />
          </form>
        </div>
      </div>
    </>
  );

}

export default SearchForm